<style scoped lang="scss">
.strengths{
  display: flex;
  margin-top: 30px;
  li{
    flex:1;
    text-align: center;
    border-right: 1px solid #eee;
    padding:0 40px;
    &:last-child{
      border: 0;
    }
    h4{
      font-size: 18px;
      margin-bottom: 10px;
      color:#014492;
    }
  }
}
.cons{
  display: none;
}
.service_chan{
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  justify-content: space-around;
  li{
    width: 190px;
    height: 188px;
    //margin-right:100px;
    background: url("../../assets/img/产品及服务/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    p{
      font-size: 16px;
      color:#4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    .liaojie{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color:#959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/产品及服务/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }
    .liaojie{
      color: #fff;
    }
  }
  li:last-child{
    margin-right: 0;
  }
}
.download{
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #E4E6EA;
  li{
    width:50%;
    padding:20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E4E6EA;
    border-right: 1px solid #E4E6EA;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1){
      border-top: 1px solid #E4E6EA;
    }
    &:nth-of-type(2){
      border-top: 1px solid #E4E6EA;
    }
    &:hover{
      color:#014492;
    }
  }
  .btn-primary{
    font-size: 14px;
    span{
      margin-right: 7px;
    }
  }
  .mr41{
    display: block;
  }
  .mr42{
    display: none;
  }
}
.table{
  tr{
    td:first-child{
      background: #F6FAFD;
    }
  }
}
.c-title small{
  margin-top: 10px;
}
.required{
  margin-top: 70px;
  background: none!important;
  margin-left: 0!important;
  font-size: 16px;
}
.desc{
  font-size: 16px;
}
.effect-lists{
  //display: block!important;
  justify-content: space-between;
  flex-wrap:wrap;
  overflow: auto;
}
//.effect-lists1{
//  //display: block!important;
//  justify-content: center;
//  flex-wrap:wrap;
//  overflow: auto;
//}
.compose-type1{
  padding-bottom: 50px;
  background: url("../../assets/img/产品及服务/基因检测/bg.png") no-repeat;
  background-size: 100% 100%;
}
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (max-width: 414px) and (min-width: 413px),
screen and (max-width: 640px) and (min-width: 600px),
screen and (min-width: 300px) and (max-width:400px)
{
  .container100{
    margin-bottom: 20px!important;
  }
  .effect-lists1{
    justify-content: flex-start!important;
  }
  .desc1{
    margin-top: 20px!important;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <div class="banner con" v-if="!$route.meta.invisibles">
      <img src="@/assets/img/产品及服务/微生物测序/banner.png" class="img-fluid">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons"  v-if="!$route.meta.invisibles">
      <img src="@/assets/img/二级标题Banner/微生物测序.jpg" class="img-fluid">
      <div class="info"></div>
    </div>
    <section v-if="!$route.meta.invisibles">
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100" style="margin-bottom: 100px;">
        <p class="desc">微生物测序是指对特定环境中的微生物群体进行基因组测序分析，主要包含两类：</p>
        <p class="desc"><span style="color:#014492;font-weight:bold;"><a href="/tec/ITS">16S/18S/ITS扩增子测序：</a></span>对微生物细菌/古菌中16s rRNA基因的可变区、真菌中的18srRNA基因可变区或真菌内转录间隔区ITS(Internal transcribed spacer)等对微生物群体进行测序,通过分析测序序列的整体结构包括微生物种类、数量、相对丰度、群落变异情况等来分析特定环境中微生物群体中各类微生物的构成、分布等情况或其相关功能。</p>
        <p class="desc"><span style="color:#014492;font-weight:bold;"><a href="/tec/macrogenome">宏基因组测序(metagenomic)：</a></span>对特定环境中全部微生物的总DNA进行克隆，并通过构建宏基因组文库和筛选等手段获得新的生理活性物质:或者根据rDNA数据库设计引物，通过系统学分析获得该环境中微生物的遗传多样性和分子生态学信息，进一步研究分析微生物与环境因素或宿主之间的关系，寻找标志性菌群或特定功能的基因，阐明样本间多样性和组成差异，进而发现差异相关物种。</p>
        <p class="desc desc1" style="margin-top: 50px;">擎科生物可提供<span style="color:#014492;font-weight:bold;"><a href="/tec/ITS">16S/18S/ITS扩增子测序、</a> <a
          href="/tec/macrogenome">宏基因组测序、</a><a href="/tec/bacterial">细菌基因组、</a><a href="/tec/fungal">真菌基因组测序</a></span>等微生物测序系列服务。</p>
      </div>
      <div class="container">
        <div class="c-title">微生物测序<small>Microbial sequencing</small></div>
        <div class="container con">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer" :class="{active1: currentService === index}" @mouseover="currentService = index" @mouseout="currentService = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/sw_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons">
          <ul class="effect-lists1 effect-lists">
            <li v-for="(item, index) in types1" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/sw_${item.img}${currentService===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>

      <div class="compose-type1" style="margin-top: 100px;">
        <div class="container">
          <div class="c-title">服务优势<small>Service advantage</small></div>
          <div class="neirong" style="display: flex">
            <div class="left ">
              <img src="@/assets/img/产品及服务/微生物测序/ys.png" class="img-fluid">
            </div>
            <div class="right">
              <div class="required">
                <p class="mb20">1.技术成熟,项目经验丰富,保证交付精准、可靠、高质量数据;</p>
                <p class="mb20">2.专业分析团队,精准分析,提供全面、个性化解决方案;</p>
                <p class="mb20">3.一对一个性化的售前售后服务,专业解答项目分析需求。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-title">资源中心<small>Resource center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>

            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" v-if="item.resourceFile.fileType === 'PICTURE'" @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关服务<small>Related services</small></div>
        <div class="container con">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer" :class="{active: currentType === index}" @mouseover="currentType = index" @mouseout="currentType = -1" @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`">
              <p style="margin-top: 10px;">{{item.name}}</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px;">
          <ul class="effect-lists">
            <li v-for="(item, index) in types" :key="index" class="pointer"  @click="$router.push(item.ref)">
              <img :src="`/static/img/Gene_${item.img}${currentType===index ? '' : ''}.png`" style="width: 60px;">
              <p style="margin-top: 10px;font-size: 12px">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus"/>
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data () {
    return {
      currentType: -1,
      currentService: -1,
      types: [
        {name: 'Sanger测序', img: '1', ref: '/sanger'},
        {name: '基因组测序', img: '2', ref: '/products/Genome_sequencing'},
        {name: '转录组测序', img: '4', ref: '/products/Transcriptome_sequencing'},
        {name: 'Fast NGS', img: '5', ref: '/tec/1.5_generation_sequencing'},
      ],
      types1: [
        {name: '16S/18S/ITS扩增子测序(二代)', img: '1', ref: '/tec/ITS'},
        {name: '16S/18S/ITS扩增子测序(三代)', img: '5', ref: '/tec/amplicon'},
        {name: '细菌基因组', img: '2', ref: '/tec/bacterial'},
        {name: '真菌基因组', img: '3', ref: '/tec/fungal'},
        {name: '宏基因组测序', img: '4', ref: '/tec/macrogenome'},
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created () {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns () {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists (id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad (imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile (item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    },
    // 翻页
    changePage (value) {
      this.page = value - 1
      this.getResourcesLists(this.categoryId)
    },

  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/Microbial_sequencing.vue